import React from 'react';

const BlogCard = ({ topic }) => {
  return (
    <div className="blog-card">
      <div className="card-image">
        <img src={topic.image} alt={topic.title} />
        <span className="category-tag">{topic.category}</span>
      </div>
      <div className="card-content">
        <div className="meta-info">
          <span className="date">{topic.date}</span>
          <span className="read-time">{topic.readTime}</span>
        </div>
        <h3>{topic.title}</h3>
        <p>{topic.excerpt}</p>
        <button className="read-more-btn">Read More</button>
      </div>
    </div>
  );
};

export default BlogCard;